import { createSlice } from '@reduxjs/toolkit'

import { initialState } from 'store/pages/location/state'

import { getBulkData } from '../actions/getBulkData'
import { getData } from '../actions/getData'

export const LocationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      const data = action.payload
      state.data.locations[data.id] = data
    })

    builder.addCase(getBulkData.fulfilled, (state, action) => {
      action.payload.forEach((location) => (state.data.locations[location.id] = location))
    })
  },
})
